import AmountItemConfig from "./AmountItemConfig";
/**
 * LineItemConfig
 *  Encapsulates line item configuration settings.
 * */
var LineItemConfig = /** @class */ (function () {
    /**
     * Create a new line item configuration.
     * @param rules Explanation rules.
     */
    function LineItemConfig(rules) {
        if (rules === void 0) { rules = []; }
        this._rules = rules;
        this._amountItemConfigurations = [];
    }
    Object.defineProperty(LineItemConfig.prototype, "rules", {
        get: function () {
            return this._rules;
        },
        enumerable: false,
        configurable: true
    });
    LineItemConfig.prototype.addAmountItemConfig = function (columnKey, config) {
        this._amountItemConfigurations.push({
            columnKey: columnKey,
            config: config
        });
    };
    LineItemConfig.prototype.getAmountItemConfigOrDefault = function (columnKey) {
        var config = this._amountItemConfigurations
            .find(function (value) { return value.columnKey == columnKey; });
        return config
            ? config.config
            : new AmountItemConfig(null, null);
    };
    LineItemConfig.prototype.getOrCreateAmountItemConfig = function (columnKey) {
        var entry = this._amountItemConfigurations
            .find(function (value) { return value.columnKey == columnKey; });
        if (entry) {
            return entry.config;
        }
        else {
            var config = new AmountItemConfig();
            this.addAmountItemConfig(columnKey, config);
            return config;
        }
    };
    return LineItemConfig;
}());
export default LineItemConfig;
